module.exports = __webpack_public_path__ + "static/media/voucher-icon.0fb67fa4.png";